execv2.form.multipletable = {};
execv2.form.fileUpload = {};

execv2.form.isAlphanumericCnpjMask = function (mask) {
    return mask && /\*\*\.\*\*\*\.\*\*\*\/\*\*\*\*-99/.test(mask);
};

execv2.form.setInputMasks = function (container) {

    if (typeof Inputmask != "undefined") {

        const inputs = container.querySelectorAll("input[data-inputmask]");

        h.forEach(inputs, function (i, input) {
            const maskValue = input.getAttribute('data-inputmask');

            if (maskValue && execv2.form.isAlphanumericCnpjMask(maskValue)) {
                if (!maskValue.includes('casing')) {
                    input.setAttribute('data-inputmask', maskValue + ", 'casing': 'upper'");
                }

                Inputmask({
                    definitions: {
                        '*': {
                            validator: '[0-9A-Za-z]',
                            casing: 'upper'
                        }
                    }
                }).mask(input);
            } else {
                Inputmask().mask(input);
            }
        });
    }
}

execv2.form.setDatePicker = function (container) {
    if (container == null) container = document;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    Array.from(container.querySelectorAll(".date-picker")).forEach(function (item) {
        if ((isMobile && item.classList.contains("flatpickr-mobile") && item.type !== 'hidden')) 
            item.remove();
    });
    bsml.setDatePicker(container);
}

execv2.form.clearFormFields = function (container) {

    const fields = container.querySelectorAll("input, select, textarea, .containerFormFileLink, div");

    h.forEach(fields, function (i, node) {
        
        if (h.hasClass(node, "containerFormFileLink")) {

            node.innerHTML = "";

        } else {
            
            const fieldtype = node.type;

            switch (fieldtype) {
            case "text":
            case "password":
            case "textarea":
            case "number":
            case "hidden":
                node.value = "";
                break;
            case "radio":
            case "checkbox":
                if (node.checked) {
                    node.checked = false;
                }
                break;
            case "select-one":
            case "select-multi":
                node.selectedIndex = 0;
                break;
            default:
                break;
            }
        }
    });
}

//Função executada ao clicar no botão de upload, para abrir pop de uplod
execv2.form.fileUpload.open = function (c, t) {
    let rowIndex = -1;
    const table = t.closest("table");
    const isMult = table ? table.getAttribute("mult") : null;

    if (isMult === "S") rowIndex = t.closest("tr").rowIndex;
    else if (table) rowIndex = 0;

    smlbpms.uploadCrypt(c, rowIndex);
}

//callback após o upload, configurado em execute-form.js
execv2.form.fileUpload.add = function (
    filename,
    filepath,
    associatedfieldname,
    viewercrypt,
    rowindex) {
    
    const label = document.querySelectorAll(`#div${associatedfieldname}`);
    const input = document.querySelectorAll(`#inp${associatedfieldname}`);

    if (label == null || label.length <= 0 || input == null || input.length <= 0) return;

    let viewerType = viewercrypt.split('|')[0];
    let viewerCryptQs = viewercrypt.split('|')[1];

    if (viewerType == 'preview_embed')
        execv2.form.fileUpload.addViewerFile(associatedfieldname, filepath, label, input, rowindex, viewerCryptQs);
    else
        execv2.form.fileUpload.addSimpleFile(filename, filepath, label, input, rowindex, viewerCryptQs);
}

//callback após realizar upload em campo anexo do tipo visualizador
execv2.form.fileUpload.addViewerFile = function (fieldName, filepath, label, input, rowIndex, viewerCrypt) {

    if (label == null || label.length <= 0 || input == null || input.length <= 0) return;

    const uid = Math.random().toString(36).substr(2, 9);

    if (label.length > 0) label = label[0];

    if (input.length > 0) input = input[0];

    if (!label || !input) return;

    label.setAttribute("data-client-uid", uid);
    input.setAttribute("data-client-uid", uid);
    input.value = filepath;

    const containerId = `divDocContent_${fieldName}`;
    const containerSpinnerId = `divDocLoad_${fieldName}`;
    let container = document.getElementById(containerId);
    let containerSpinner = document.getElementById(containerSpinnerId);

    if (!container && rowIndex >= 0) {
        const row = label.closest("tr");
        row.insertAdjacentHTML("afterEnd",
            `<tr>
                <td colspan="2">
                    <div class="spinner spinner-sm" id="${containerSpinnerId}"></div>
                    <div id="${containerId}"></div>
                </td>
            </tr>`);
    }
    else if (!container) {
        const button = document.getElementById(`btnUpload${fieldName}`);
        button.insertAdjacentHTML("afterEnd",
            `<div class="m-3">
                <div class="spinner spinner-sm" id="${containerSpinnerId}"></div>
                <div id="${containerId}"></div>
            </div>`
        );
    }

    if (!container) {
        container = document.getElementById(containerId);
        containerSpinner = document.getElementById(containerSpinnerId);
    }

    container.innerHTML = "";

    bsml.show(containerSpinner);

    const parts = filepath.split("/").pop().split(".");
    parts.pop();
    let url = `${window.appvars.baseurl}/document/preview_embed/${parts[0]}${viewerCrypt}`;

    //TODO: trocar para retirar JQUERY
    $(container).load(url,
        function () {
            bsml.hide(containerSpinner);
        }
    );

}

execv2.form.fileUpload.getPreview = function (filePath, queryString) {
    const parts = filePath.split("/").pop().split(".");
    parts.pop();
    return  `${window.appvars.baseurl}/document/preview/${parts[0]}${queryString}`;
}

//callback após realizar upload em campo simples em visualizador
execv2.form.fileUpload.addSimpleFile = function (filename, filepath, label, input, rowindex, querystring) {

    const uid = Math.random().toString(36).substr(2, 9);

    if (label == null || label.length <= 0 || input == null || input.length <= 0) return;
    
    if (rowindex > 0 && label.length > 1 && input.length > 1) {

        label = label[rowindex - 1];
        input = input[rowindex - 1];
    } else {

        label = label[0];
        input = input[0];
    }

    label.setAttribute("data-client-uid", uid);
    input.setAttribute("data-client-uid", uid);
    input.value = filepath;

    let previewUrl = execv2.form.fileUpload.getPreview(filepath, querystring);

    label.innerHTML = `<div class="containerFormFileLink">
                            <a href="${previewUrl}" target="_blank" class="small">${filename}</a>
                            <a href="javascript:void(0)" class="ml-3" title="${mlLblDelete}" onclick="javascript:execv2.form.fileUpload.delete('${uid}')">
                                <i class="ico-delete ico-sm text-danger"></i>
                            </a>
                        </div>`;

    bsml.convertIcons(label);
    input.value = filepath;
}


//excluir um upload após o upload
execv2.form.fileUpload.delete = function (clientuid) {
    const label = document.querySelector(`div[data-client-uid="${clientuid}"]`);
    const input = document.querySelector(`input[data-client-uid="${clientuid}"]`);
    if (label != null) label.innerHTML = "";
    if (input != null) input.value = "";
}


//executada no carregamento da tarefa para arquivos já executados.
execv2.form.fileUpload.load = function (associatedcodfield, associatedfieldname, filename, urltopreview, urltodownload) {

    var containers = document.querySelectorAll(`#div${associatedcodfield}`);
    if (containers == null || containers.length ===0)
        containers = document.querySelectorAll(`#div${associatedfieldname}`);
    

    if (containers == null || containers.length === 0) return;

    const countAlreadySameFieldNameFound = execv2.form.fileUpload.counter.filter(x => x === associatedfieldname).length;
    const lenght = countAlreadySameFieldNameFound > containers.length
        ? containers.length
        : countAlreadySameFieldNameFound+1;

    const index = lenght === 0
        ? 0
        : lenght - 1;

    const html = filename.length != 0 ? `  <a href="${urltopreview}" target="_blank" class="small">${filename}</a>
                    <a href="${urltodownload}" class="d-none d-md-inline-block ml-3 " donwload >
                        <i class="ico-arrow-down  ico-sm text-muted mb-1 "></i>
                    </a>` : '';

    // Em algumas ocasiões o index estava chegando maior que o length
    if (index >= containers.length) return;

    const container = containers[index];
    container.className = "containerFormFileLink";
    container.innerHTML = html;

    execv2.form.fileUpload.counter.push(associatedfieldname);
    
}

execv2.form.fileUpload.counter = [];

//Trata-se de uma nova implementacao da cryo_fillValue sem jQuery.
// key: é o identificador (string) do campo do formulario
// v: é o valor a ser preenchido
// origin: é o campo original que esta promovendo a alteração do campo key
execv2.form.fillValue = function (key, v, origin, fromcache) {
    fromcache = fromcache || false;
    var field, div;
    var formRoot = document.forms[0];
    var rowRoot = origin.closest("tr");
    var fields = formRoot.querySelectorAll("[xname='inp" + key + "']");
    if (fields.length > 0) {
        //multivalorada
        if (fields.length > 1) {
            field = rowRoot.querySelector("[xname='inp" + key + "']");
            div = rowRoot.querySelector("[xid='div" + key + "']");
        } else {
            field = formRoot.querySelector("[xname='inp" + key + "']");
            div = formRoot.querySelector("[xid='div" + key + "']");
        }
        if (field) {
            if (field.value != v) {
                field.value = v;
                field.dispatchEvent(new Event("change"));
            }
            field.setAttribute("data-from-cache", fromcache);
        }
        if (div) {
            div.innerHTML = v;
            field.setAttribute("data-from-cache", fromcache);
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const isAlphaCnpj = (el) => el.tagName === 'INPUT' && execv2.form.isAlphanumericCnpjMask(el.getAttribute('data-inputmask'));

    document.addEventListener('keydown', (e) => {
        if (isAlphaCnpj(e.target) && e.key.length === 1 && !/^[0-9A-Za-z]$/.test(e.key)) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    }, true);

    document.addEventListener('input', (e) => {
        if (isAlphaCnpj(e.target) && e.target.value !== e.target.value.toUpperCase()) {
            const pos = e.target.selectionStart;
            e.target.value = e.target.value.toUpperCase();
            e.target.setSelectionRange(pos, pos);
        }
    }, true);
});